import { Alert, Box, Typography } from '@mui/material';
import React from 'react';
import type { MigrationJob } from '../../data/types';
import DataTable from '../../ui/DataTable';
import { StatCard, StatGrid } from '../../ui/primitives';

const MAPPING = [
  { source: 'Holder Name', target: 'Registered name', confidence: 'Exact' },
  { source: 'Holder No', target: 'Previous account number', confidence: 'Exact' },
  { source: 'Units Held', target: 'Opening units', confidence: 'Exact' },
  { source: 'TFN Status', target: 'TFN status (values mapped)', confidence: 'Mapped' },
  { source: 'Bank BSB / Bank Acct', target: 'Bank account (encrypted)', confidence: 'Exact' },
  { source: 'Reg Address 1–3', target: 'Registered address', confidence: 'Mapped' },
  { source: 'Email', target: 'Primary contact email', confidence: 'Exact' },
  { source: 'DRP', target: 'DRP election', confidence: 'Suggested' },
];

export default function MigrationJobDetail({ job }: { job: MigrationJob }) {
  return (
    <Box sx={{ mt: 2 }}>
      <StatGrid min={150}>
        <StatCard label="Rows" value={job.rows} />
        <StatCard label="Matched to existing" value={job.matched} tone="success" />
        <StatCard label="New holders" value={job.newHolders} tone="info" />
        <StatCard
          label="Exceptions"
          value={job.exceptions}
          tone={job.exceptions ? 'warning' : 'neutral'}
        />
        <StatCard
          label="Units variance"
          value={job.unitsVariance.toFixed(4)}
          tone={job.unitsVariance ? 'danger' : 'success'}
        />
      </StatGrid>
      {job.exceptions > 0 && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          1 holder matched two existing contacts with the same name (different emails). Choose the
          right one or create a new holder before reconciling.
        </Alert>
      )}
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Column mapping
      </Typography>
      <DataTable
        rows={MAPPING}
        rowKey={(row) => row.source}
        dense
        columns={[
          { key: 'source', label: `${job.source} column`, render: (row) => row.source },
          { key: 'target', label: 'Registry field', render: (row) => row.target },
          { key: 'confidence', label: 'Mapping', render: (row) => row.confidence },
        ]}
      />
    </Box>
  );
}
